import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAdvertisements, postAdvertisementPlay } from '../services/advertisementsServices';

export const fetchAdvertisements = createAsyncThunk(
    'advertisements/fetch',
    async (deviceToken, { rejectWithValue }) => {
        try {
            const data = await getAdvertisements(deviceToken);
            return data;
        } catch (error) {
            const errorMessage =
                error.response?.data?.detail || 'Ошибка получения рекламы';
            return rejectWithValue(errorMessage);
        }
    }
);

export const createAdvertisementPlay = createAsyncThunk(
    'advertisements/play',
    async ({ advertisementId, deviceToken, placement, completed, watchedMs }, { rejectWithValue }) => {
        try {
            const extra = {};
            if (placement) extra.placement = placement;
            if (typeof completed === 'boolean') extra.completed = completed;
            if (Number.isFinite(watchedMs)) extra.watched_ms = Math.max(0, Math.round(watchedMs));
            const data = await postAdvertisementPlay(advertisementId, deviceToken, extra);
            return data;
        } catch (error) {
            const errorMessage =
                error.response?.data?.detail || 'Ошибка записи воспроизведения рекламы';
            return rejectWithValue(errorMessage);
        }
    }
);
